import React from 'react';
import {Redirect,Route,useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
const PublicRoute = ({component: Component,restricted, ...rest}) => {
    const session=useSelector((state)=>state.sessionStore)
    const location=useLocation()
    let url="/"
    if(location.state){
        url=location.state.from
    }
    return (

        <Route {...rest} render={props => (
            session.token && session.expire_at>new Date().valueOf() && restricted  ?
            <Redirect to={url} />
            : <Component {...props} />
        )} />
    );
};

export default PublicRoute; 


